import React from 'react';

export default function Back() {
  return <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10 1.51671L8.48329 0L0 8.48329L8.48329 16.9666L10 15.4499L3.03342 8.48329L10 1.51671Z" fill="#BBBBBB"/>
	</svg>
}
